export default __webpack_public_path__ + "static/postgresql-ba5dc99c80f8760c201565d408a66795.png";